import constants from './ReservationsConstants';

const initialState = {
    reservation: [],
};


export default (state = initialState, action) => {
    switch (action.type) {
    case constants.SET_RESERVATION: {
        return Object.assign({}, state, { reservation: [...state.reservation, action.payload] });
    }
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ReservationsReducer/ReservationsReducer.js